import Component from 'vue-class-component';
import { Prop , Mixins , Watch} from 'vue-property-decorator';
import { SECTION_TYPES} from '@/content/values/sections';
import { COURSE_MATERIAL_KEYS } from '@/courses/values/courses.values';
import KEYS from '@/values/keys'
import EdFileViewer from '@/content/components/ed-file-viewer/ed-file-viewer.vue';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import { HOMEWORK_STATUS } from '@/homework/values/homeworks.values';

@Component({
  name: 'ed-material-viewer',
  components: {
    EdFileViewer
  }
})
export default class EdMaterialViewer extends Mixins(CourseToolsMixin) {

  /* Props */
  @Prop() readonly section: any;
  @Prop() readonly sectionMaterial: any;
  @Prop() readonly isSplitObject: boolean;
  @Prop({default: false, required: false}) isPresentationFile : boolean;
  @Prop({default: 0}) documentIndex: number;
  @Prop() readonly courseId: number;

  /* Data */
  public fileType: string = '';

  /* Methods */
  private pagePlusOffset(page: any): number {
    return parseInt(page) + this.offset;
  }

  private getIsResponse(pdfUrl) {
    if(this.section.homework && this.section.homeworkInfo) {
      switch(this.section.homeworkStatus) {
        case HOMEWORK_STATUS.FINISHED:
        case HOMEWORK_STATUS.GRADED:
        case HOMEWORK_STATUS.FEEDBACK_DRAFT:
        case HOMEWORK_STATUS.NEW: 
        case HOMEWORK_STATUS.SEEN: 
          return this.section.homeworkInfo.homeworkAssetInfo.url;
      }
    }
    return pdfUrl;
  }

  private setUrlDisplay(fileType: string , isMaterialObject: boolean): string {
    let startPage: number = isMaterialObject ? ( this.section.sectionId ? this.calculateStartPages : 1 ) : this.offset + 1;
    const splicedOrRotatedUrl = this.section.assetsInfo?.[0].pdfUrl || this.sectionMaterial.splicedUrl; //when it's a spliced object or an object that has rotated pages.
    const materialUrl = this.sectionMaterial.data.pdfUrl; // when it's a material object without any splice or page rotation.
    let url: string = splicedOrRotatedUrl || materialUrl;

    if( !url ) {
      return null;
    }

    url = `${url}#toolbar=0&navpanes=0&scrollbar=0&page=${startPage}`;
    url = this.getIsResponse(url);
    return url;
  }

  /* Computed */
  get isSpliceObject(): boolean {
    return this.section.sectionMaterial ? 
    this.section.sectionMaterial.displayType === COURSE_MATERIAL_KEYS.SPLICE : false;
  }

  get isSplicedUrl(): boolean {
    return this.section.sectionMaterial ? this.section.sectionMaterial.splicedUrl != null : false;
  }

  get startPage(): number {    
    if (this.section.sectionMaterial)
    return !this.isSpliceObject && !this.isPresentationMode ? Number(this.section.sectionMaterial.startSection) : null;
    else
    null
  }

  get offset(): number {
    return this.sectionMaterial.data.offset ? this.sectionMaterial.data.offset : 0;
  }

  get urlDisplay(): string {
    let url: string = '';
    let sectionType: boolean = this.section && this.section.type == SECTION_TYPES.LESSON_MATERIAL.code;
    if( sectionType && this.section.sectionId ) {    
      this.fileType = ( this.isSpliceObject && this.isSplicedUrl ) || (!this.isSpliceObject && this.sectionMaterial.data.pdfUrl) ? 
      KEYS.FILES_TYPE.PDF : this.sectionMaterial.data.subtype;
        url = this.setUrlDisplay(this.fileType , sectionType);
    } else {      
      this.fileType = (this.sectionMaterial.data.pdfUrl || this.sectionMaterial.splicedUrl) ? KEYS.FILES_TYPE.PDF : this.sectionMaterial.data.subtype;
      url = this.setUrlDisplay(this.fileType , sectionType);
    } 
    return url;
  }

  get viewerId(): string {
    let id = new Date().getTime();
    return `${this.urlDisplay}${id}`
  }

  get calculateStartPages(): number {
    let pages: number = this.pagePlusOffset(this.section.sectionMaterial.startSection);
    if(pages > this.sectionMaterial.data.numberOfPages) {
      return this.offset + 1;
    } else {
      return pages;
    }
  }

  get footerPages(): string {
    if(this.section.type == SECTION_TYPES.LESSON_MATERIAL.code && !this.isSplicedUrl && (this.section.sectionId || this.section.id)) { 
       let footPage: string = String(this.$i18n.t('courses.materials.fromStart', {type: this.$i18n.t('courses.materials.page'),
        start: this.calculateStartPages}));
      return footPage;
    } else  
      return null;
  }
  
  get showNotice(): boolean {
    if(this.section.sectionId) {
      return this.isSpliceObject && !this.isSplicedUrl;
    } else {
      return !this.sectionMaterial.data.pdfUrl;
    }
  }

  get getCourseId(): number {
    return this.sectionMaterial.courseId ? this.sectionMaterial.courseId : this.section.courseId ? this.section.courseId : this.courseId;
  }

  get getClassId(): number {
    return this.sectionMaterial.classId ? this.sectionMaterial.classId : this.section.classId;
  }

  get isPresentationMode() : boolean{
    return this.$store.state.CourseStore.isPresentationStudentMode || this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  /* Watchers */
  @Watch('viewerId', { immediate: true, deep: true })
  setFileInfoReady() {
    if(this.showNotice) {
      let fileData: any = { 
        sectionId: this.isSplitObject ? this.section.parentId : this.section.sectionId, 
        materialId: this.sectionMaterial.relatedContentId || this.sectionMaterial.materialId, 
        courseId: this.getCourseId, 
        classId: this.getClassId
      };
      this.checkStorage(fileData.sectionId , fileData.materialId);
      let intervalId: any = setInterval((data) => {
        this.waitForReadyFileInfo(intervalId , data);
      }, 15000 , fileData);
    }
  }

}